// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company__radio {
  height: 76px;
  max-width: 343px;
  width: 100%;
  margin: 6px 0;
  border-radius: 8px;
  border: 1px solid #b6bfc8;
  display: flex;
  background-color: #fff;
  justify-content: space-between;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
}
@media (max-width: 350px) {
  .company__radio {
    margin: 4px 0;
  }
}
.company__radio__checkbox-comp .BaSe--checkbox div {
  margin-top: 3px;
}
.company__radio__checkbox-comp .BaSe--checkbox div:last-child {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  width: 18px;
  height: 18px;
}
.company__radio__data {
  display: flex;
  padding-left: 25px;
  align-items: center;
  gap: 11.6px;
}
.company__radio__data__text {
  display: flex;
  flex-direction: column;
}
.company__radio__data__text .company-name {
  max-width: 25ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .company__radio__data__text .company-name {
    max-width: 18ch;
  }
}
.company__radio:hover {
  cursor: pointer;
  border: 3px solid #005eb8;
}
.company__radio.selected {
  border: 3px solid #005eb8;
}`, "",{"version":3,"sources":["webpack://./src/components/cards/card-input-company/index.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,wCAAA;AACF;AACE;EAZF;IAaI,aAAA;EAEF;AACF;AAEM;EACE,eAAA;AAAR;AAEQ;EACE,wCAAA;EACA,WAAA;EACA,YAAA;AAAV;AAME;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAJJ;AAMI;EACE,aAAA;EACA,sBAAA;AAJN;AAMM;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAJR;AAMQ;EANF;IAOI,eAAA;EAHR;AACF;AAQE;EACE,eAAA;EACA,yBAAA;AANJ;AASE;EACE,yBAAA;AAPJ","sourcesContent":[".company__radio {\n  height: 76px;\n  max-width: 343px;\n  width: 100%;\n  margin: 6px 0;\n  border-radius: 8px;\n  border: 1px solid #b6bfc8;\n  display: flex;\n  background-color: #fff;\n  justify-content: space-between;\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);\n\n  @media (max-width: 350px) {\n    margin: 4px 0;\n  }\n\n  &__checkbox-comp {\n    .BaSe--checkbox {\n      div {\n        margin-top: 3px;\n\n        &:last-child {\n          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n  }\n\n  &__data {\n    display: flex;\n    padding-left: 25px;\n    align-items: center;\n    gap: 11.6px;\n\n    &__text {\n      display: flex;\n      flex-direction: column;\n\n      .company-name {\n        max-width: 25ch;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n\n        @media (max-width: 768px) {\n          max-width: 18ch;\n        }\n      }\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n    border: 3px solid #005eb8;\n  }\n\n  &.selected {\n    border: 3px solid #005eb8;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
